import { Controller } from "stimulus";

export default class BeforeAfterPhotos extends Controller {
	before_after_photos_container: HTMLElement;
	clickLeft() {
		this.element.querySelector(".before-after-photos-container").scrollLeft -= 1100;
	}

	clickRight() {
		this.element.querySelector(".before-after-photos-container").scrollLeft += 1100;
	}

	refreshDots() {
		const dots_container = this.element.querySelector(
			".before-after-photos-dots-container"
		);
		const box_number = Math.round(
			(this.before_after_photos_container.scrollLeft /
				this.before_after_photos_container.scrollWidth) *
				dots_container.children.length
		);
		const to_activate = dots_container.children.item(box_number);
		dots_container
			.querySelectorAll(".before-after-photos-dot--active")
			.forEach((element) => {
				if (element !== to_activate) {
					element.classList.remove("before-after-photos-dot--active");
				}
			});
		to_activate.classList.add("before-after-photos-dot--active");
	}

	blurSidePictures() {
		const box_number = Math.round(
			(this.before_after_photos_container.scrollLeft /
				this.before_after_photos_container.scrollWidth) *
				this.before_after_photos_container.children.length
		);
		const to_activate = this.before_after_photos_container.children.item(box_number);
		this.before_after_photos_container
			.querySelectorAll(".image-pair-box--active")
			.forEach((element) => {
				if (element !== to_activate) {
					element.classList.remove("image-pair-box--active");
				}
			});
		to_activate.classList.add("image-pair-box--active");
	}

	connect() {
		this.before_after_photos_container = this.element.querySelector(
			".before-after-photos-container"
		);
		this.before_after_photos_container.addEventListener("scroll", () => {
			this.blurSidePictures();
			this.refreshDots();
		});

		this.refreshDots();
		this.blurSidePictures();
	}
}
